// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2wHe3","consentsList":"PatientConsents_consentsList__so4uG","consentsListEmpty":"PatientConsents_consentsListEmpty__3ETp5"};